import axios from 'axios'

// URL base dell'API per le proposte, recuperato dall'env file

const PROPOSTA_REST_API_URL = process.env.REACT_APP_API_PREFIX + 'proposta'

const headers = { 'Content-Type': 'application/json' }

class PropostaService {

    /**
     * Salva o aggiorna una proposta nel sistema.
     * Effettua una richiesta POST a `/proposta/save` con i dati della proposta.
     *
     * @param {Object} proposta - Oggetto contenente i dettagli della proposta da salvare.
     * @returns {Promise} - Una promessa che restituisce la risposta del server dopo il salvataggio.
     */
    saveProposta(proposta) {
        return axios.post(PROPOSTA_REST_API_URL + "/save", proposta, headers)
    }

    /**
     * Recupera una proposta specifica in base al suo ID.
     * Effettua una richiesta GET a `/proposta/{proId}`.
     *
     * @param {number} proId - L'ID della proposta da recuperare.
     * @returns {Promise} - Una promessa che restituisce i dettagli della proposta.
     */
    getProposta(proId) {
        return axios.get(PROPOSTA_REST_API_URL + `/${proId}`)
    }
}

// Creazione dell'istanza per essere importata direttamente nei componenti
const propostaServiceInstance = new PropostaService()
export default propostaServiceInstance;